import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-vendor-master-management',
  templateUrl: './vendor-master-management.component.html',
  styleUrls: ['./vendor-master-management.component.css']
})
export class VendorMasterManagementComponent implements OnInit {

  data: any;
  cid:any
  form: any | FormGroup
  modelSubtitle = false
  product:any = []
  checked = false
  name = ""
  version = ""
  code = ""
  description = ""
  isActive = false
  i: any;
  deleteId: any = "";

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getallVendor()
    this.form = this.fb.group({
      name: [''],
      version: [''],
      group:[''],
      code:[''],
      description:['']
    })  
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getallVendor()
  }

  addVendor(){
    let body = {
      "version": String(this.form.get('version').value),
      "isActive": true,
      "description":String(this.form.get('description').value),
      "code": String(this.form.get('code').value),
      "name": String(this.form.get('name').value),
      "status": "string",
      "cid": this.cid
      }

    console.log(body)
    this.generic_service.addVendor(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getallVendor()
        this.toastr.success(response.message);
        this.cancelModel()
        this.form.reset()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getallVendor(){
    // this.generic_service.getVendor().subscribe(
    //   (response:any)=>{
    //     console.log(response)
    //     this.product = response.response;
    //     this.totalRecords = response.response.length;
    //   }
    // )
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.code = ""
    this.description = ""
    this.isActive = false
  }

  deleleVendor(){
    this.generic_service.delVendor(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success(res.message);
        this.getallVendor();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

}